// extracted by mini-css-extract-plugin
module.exports = {"root":"az_t6c","ratingRadioButton":"az_u6c","ratingItemIcon":"az_v6c","empty":"az_w6c","a11label":"az_x6c"};